<template>
  <div class="work-order-business-trends">
      <div class="trends-container">
        <div class="trend-header">
          <div class="tabs-container">
            <div class="compact-tabs business-tabs">              <div 
                v-for="tab in tabs" 
                :key="tab.key"
                :class="['tab-item', { active: activeTab === tab.key }]"
                @click="switchTab(tab.key)"
              >
                {{ tab.label }}
              </div>
            </div>
            <div class="compact-tabs time-tabs">              <div 
                v-for="time in timeOptions" 
                :key="time.key"
                :class="['tab-item', { active: timeType === time.key }]"
                @click="switchTime(time.key)"
              >
                {{ time.label }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="trend-stats">
          <div class="stat-card" v-for="(stat, index) in trendStats" :key="index">
            <div class="stat-label">{{ stat.label }}</div>
            <div class="stat-value">{{ formatNumber(stat.value) }}</div>
            <div class="stat-change" :class="getTrendClass(stat.change)">
              <i :class="getTrendIcon(stat.change)"></i>
              {{ formatChange(stat.change) }}
            </div>
          </div>
        </div>
        
        <div class="chart-section">
          <div ref="chartRef" class="chart"></div>
        </div>
      </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { postAction } from '@/api/manage'

export default {
  name: 'WorkOrderBusinessTrends',
  components: {

  },
  data() {
    return {
      chart: null,
      activeTab: -1,
      tabs: [
        { key: -1, label: this.$t('全部') },
        { key: 0, label: this.$t('换表') },
        { key: 1, label: this.$t('工程报装') },
        { key: 2, label: this.$t('故障报修') }
      ],
      timeType: 0,
      timeOptions: [
        { key: 0, label: this.$t('近七天') },
        { key: 1, label: this.$t('近一月') },
        { key: 2, label: this.$t('近半年') }
      ],
      trendStats: [
        { label: this.$t('总工单'), value: 0, change: 0 },
        { label: this.$t('完成率'), value: 0, change: 0 },
        { label: this.$t('平均时长'), value: 0, change: 0 },
        { label: this.$t('满意度'), value: 0, change: 0 }
      ],
      chartData: {
        categories: [],
        series: []
      },
      url: {
        queryBusinessTrends: "/jeecg-engineering/ticket/index/largeScreen/queryBusinessTrends"
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.disposeChart()
  },
  methods: {
    async init() {
      await this.getData()
      this.initChart()
    },
    async getData() {
      try {
        const res = await postAction(this.url.queryBusinessTrends, { 
          ticketsType: this.activeTab === -1 ? '' : this.activeTab,
          timeType: this.timeType
        })
        
        if (res.success && res.result) {
          this.processChartData(res.result)
          this.updateTrendStats(res.result)
        } else {
          this.loadMockData()
        }
      } catch (error) {
        console.error('获取工单业务趋势数据失败:', error)
        this.loadMockData()
      }
    },
    processChartData(data) {
      var xData = []
      var yDataNum = []
      var yDataRate = []
      
      if (this.timeType === 0 || this.timeType === 1) {
        data.map(item => {
          xData.push(item.time.split(' ')[0].split('-')[1] + '-' + item.time.split(' ')[0].split('-')[2])
          yDataNum.push(item.ticketsNum)
          yDataRate.push(item.finishRate * 100)
        })
      } else {
        data.map(item => {
          xData.push(item.time.split(' ')[0].split('-')[0] + '-' + item.time.split(' ')[0].split('-')[1])
          yDataNum.push(item.ticketsNum)
          yDataRate.push(item.finishRate * 100)
        })
      }
      
      this.chartData.categories = xData
      this.chartData.series = [
        { name: this.$t('工单数'), data: yDataNum },
        { name: this.$t('完结率(%)'), data: yDataRate }
      ]

      this.initChart()
    },
    updateTrendStats(data) {
      const totalTickets = data.reduce((sum, item) => sum + (item.ticketsNum || 0), 0)
      const avgFinishRate = data.reduce((sum, item) => sum + (item.finishRate * 100 || 0), 0) / data.length
      
      this.trendStats = [
        { label: this.$t('总工单'), value: totalTickets || 0, change: 0.15 },
        { label: this.$t('完成率'), value: avgFinishRate || 92.5, change: 0.08 },
        { label: this.$t('平均时长'), value: 2.3, change: -0.12 },
        { label: this.$t('满意度'), value: 4.7, change: 0.05 }
      ]
    },
    loadMockData() {
      // 生成模拟数据
      const mockData = this.generateMockData()
      this.processChartData(mockData)
      this.updateTrendStats(mockData)
    },
    generateMockData() {
      const categories = this.activeTab === 'week' 
        ? [this.$t('周一'), this.$t('周二'), this.$t('周三'), this.$t('周四'), this.$t('周五'), this.$t('周六'), this.$t('周日')]
        : this.activeTab === 'month'
        ? Array.from({ length: 30 }, (_, i) => `${i + 1}${this.$t('日')}`)
        : [this.$t('1月'), this.$t('2月'), this.$t('3月')]

      const createTickets = categories.map(() => Math.floor(Math.random() * 50) + 20)
      const completeTickets = createTickets.map(val => Math.floor(val * (0.8 + Math.random() * 0.15)))
      const avgDuration = categories.map(() => (Math.random() * 3 + 1).toFixed(1))

      return {
        categories,
        series: [
          { name: this.$t('创建工单'), data: createTickets },
          { name: this.$t('完成工单'), data: completeTickets },
          { name: this.$t('平均时长(小时)'), data: avgDuration }
        ],
        totalTickets: createTickets.reduce((a, b) => a + b, 0),
        totalChange: 0.15,
        completionRate: 92.5,
        completionChange: 0.08,
        avgDuration: 2.3,
        durationChange: -0.12,
        satisfaction: 4.7,
        satisfactionChange: 0.05
      }
    },
    generateCategories() {
      return this.activeTab === 'week' 
        ? [this.$t('周一'), this.$t('周二'), this.$t('周三'), this.$t('周四'), this.$t('周五'), this.$t('周六'), this.$t('周日')]
        : this.activeTab === 'month'
        ? Array.from({ length: 30 }, (_, i) => `${i + 1}${this.$t('日')}`)
        : [this.$t('1月'), this.$t('2月'), this.$t('3月')]
    },
    generateSeries() {
      const categories = this.generateCategories()
      const createTickets = categories.map(() => Math.floor(Math.random() * 50) + 20)
      const completeTickets = createTickets.map(val => Math.floor(val * (0.8 + Math.random() * 0.15)))
      const avgDuration = categories.map(() => (Math.random() * 3 + 1).toFixed(1))

      return [
        { name: this.$t('创建工单'), data: createTickets },
        { name: this.$t('完成工单'), data: completeTickets },
        { name: this.$t('平均时长(小时)'), data: avgDuration }
      ]
    },
    initChart() {
      this.disposeChart()
      
      if (!this.$refs.chartRef) return
      
      this.chart = echarts.init(this.$refs.chartRef)
      
      const option = {
        color: ['#4634FA', '#F6BB2F', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#0C2D82', '#B620E0', '#F7B500', '#FA6400', '#E02020'],
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,11,42,0.9)',
          borderColor: '#5D6A94',
          borderWidth: 1,
          borderRadius: 8,
          textStyle: {
            color: '#CEE2FF',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#019AF3'
            }
          }
        },
        legend: {
          type: 'scroll',
          data: [this.$t('工单数'), this.$t('完结率(%)')],
          textStyle: {
            color: '#CEE2FF'
          },
          icon: 'circle',
          itemHeight: 10,
          left: 'center',
          top: 0,
          right: 0
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.chartData.categories,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: ['#074671'],
            }
          },
          axisLabel: {
            color: '#D1F3FF',
            fontSize: 10
          }
        },
        yAxis: [{
            type: 'value',
            interval: 10,
            name: this.$t('工单数(件)'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center',
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            name: this.$t('完结率(%)'),
            nameTextStyle: {
              color: '#D1F3FF',
              align: 'center',
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value} %',
              color: '#D1F3FF',
              fontSize: 10
            }
          }
        ],
        series: [
          {
            name: this.$t('工单数'),
            type: 'bar',
            barMaxWidth: 14,
            stack: 'sum',
            smooth: true,
            symbol: "none",
            animationDelay: (0 * 200) - 100,
            animationDuration: 300,
            data: this.chartData.series[0]?.data || [],
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00E4FF' },
                { offset: 1, color: '#0099CC' }
              ])
            }
          },
          {
            name: this.$t('完结率(%)'),
            type: 'line',
            yAxisIndex: 1,
            symbol: 'circle',
            animationDelay: 1000,
            stack: 'Total',
            smooth: true,
            animationDuration: 300,
            data: this.chartData.series[1]?.data || [],
            lineStyle: {
              color: '#FFB800',
              width: 3
            },
            itemStyle: {
              color: '#FFB800',
              borderColor: '#0A1A3A',
              borderWidth: 2
            }
          }
        ]
      }
      
      this.chart.setOption(option)
      
      window.addEventListener('resize', this.handleResize)
    },
    switchTab(tabKey) {
      this.activeTab = tabKey
      this.getData()
    },
    switchTime(timeKey) {
      this.timeType = timeKey
      this.getData()
    },
    getTrendClass(change) {
      return change >= 0 ? 'trend-up' : 'trend-down'
    },
    getTrendIcon(change) {
      return change >= 0 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    },
    formatChange(change) {
      const symbol = change >= 0 ? '+' : ''
      return `${symbol}${(change * 100).toFixed(1)}%`
    },
    formatNumber(num) {
      return num.toLocaleString()
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    disposeChart() {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
        window.removeEventListener('resize', this.handleResize)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.work-order-business-trends {
  height: 100%;
  padding: 10px;
}

.trends-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
}

.trend-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.tabs-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.compact-tabs {
  display: flex;
  gap: 1px;
  background: rgba(8, 48, 111, 0.2);
  border: 1px solid rgba(0, 170, 255, 0.15);
  border-radius: 3px;
  padding: 1px;
  height: 24px;
}

.tab-item {
  padding: 3px 6px;
  color: #7993b3;
  font-size: 11px;
  cursor: pointer;
  border-radius: 2px;
  transition: all 0.2s ease;
  line-height: 1;
  display: flex;
  align-items: center;
  
  &.active {
    background: rgba(0, 170, 255, 0.2);
    color: #cbdff7;
    border-color: rgba(0, 170, 255, 0.3);
  }
  
  &:hover:not(.active) {
    background: rgba(0, 170, 255, 0.1);
    color: #b6deff;
  }
}

.trend-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}

.stat-card {
  background: rgba(0, 48, 111, 0.3);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 4px;
  padding: 8px 6px;
  text-align: center;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 48, 111, 0.5);
    border-color: rgba(0, 170, 255, 0.4);
  }
}

.stat-label {
  color: #b6deff;
  font-size: 10px;
  margin-bottom: 2px;
}

.stat-value {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 1px;
}

.stat-change {
  font-size: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  
  &.trend-up {
    color: #52c41a;
  }
  
  &.trend-down {
    color: #ff4d4f;
  }
}

.chart-section {
  flex: 1;
  min-height: 200px;
}

.chart {
  width: 100%;
  height: 100%;
}

@media (max-width: 1600px) {
  .trend-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .tab-item {
    padding: 2px 4px;
    font-size: 10px;
  }
  
  .compact-tabs {
    height: 22px;
  }
  
  .stat-card {
    padding: 6px 4px;
  }
  
  .stat-label {
    font-size: 9px;
  }
  
  .stat-value {
    font-size: 11px;
  }
  
  .stat-change {
    font-size: 8px;
  }
}

@media (max-width: 1200px) {
  .trend-stats {
    grid-template-columns: 1fr;
  }
  
  .trend-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .tabs-container {
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
  }
  
  .compact-tabs {
    height: 20px;
  }
  
  .tab-item {
    padding: 2px 3px;
    font-size: 9px;
  }
  
  .stat-card {
    padding: 4px;
  }
  
  .stat-label {
    font-size: 9px;
  }
  
  .stat-value {
    font-size: 12px;
  }
  
  .stat-change {
    font-size: 8px;
  }
}
</style>